// extracted by mini-css-extract-plugin
export default {"label":"Fc1kuXWJPI3x9IdvUgjd","root":"HpCkMnbU4MhzxLZENGsS"};